// extracted by mini-css-extract-plugin
export var orderSummary = "_tp-0";
export var showMoreLessButton = "_tp-1";